module.exports = __webpack_public_path__ + "static/media/grin-beam.002fe324.svg";